import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_AnimatedInputLabelLayout = _resolveComponent("AnimatedInputLabelLayout")!

  return (_openBlock(), _createBlock(_component_AnimatedInputLabelLayout, {
    label: _ctx.label,
    value: _ctx.$attrs.value,
    isFocused: _ctx.isFocused || _ctx.isFocusedInternal,
    hasPlaceholder: _ctx.hasPlaceholder
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_input, _mergeProps({
        autocomplete: _ctx.$attrs.autocomplete ?? 'disabled'
      }, _ctx.$attrs, {
        "on-focus": _ctx.focusHandler,
        "on-blur": _ctx.blurHandler,
        maxlength: _ctx.maxlength,
        ref: "inputRef",
        placeholder: _ctx.placeholder,
        autocorrect: "disabled",
        autocapitalize: "disabled",
        spellcheck: "false",
        onKeypress: _cache[0] || (_cache[0] = ($event: any) => (_ctx.allowLatinSymbolsNumbers($event))),
        onDrop: _cache[1] || (_cache[1] = ($event: any) => (_ctx.allowLatinSymbolsNumbers($event))),
        onPaste: _cache[2] || (_cache[2] = ($event: any) => (_ctx.allowLatinSymbolsNumbers($event)))
      }), {
        prefix: _withCtx(() => [
          _renderSlot(_ctx.$slots, "prefix")
        ]),
        suffix: _withCtx(() => [
          _renderSlot(_ctx.$slots, "suffix")
        ]),
        addonAfter: _withCtx(() => [
          _renderSlot(_ctx.$slots, "addonAfter")
        ]),
        _: 3
      }, 16, ["autocomplete", "on-focus", "on-blur", "maxlength", "placeholder"])
    ]),
    _: 3
  }, 8, ["label", "value", "isFocused", "hasPlaceholder"]))
}